import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'
import Forniture from './Forniture'
import Navigator from './Navigator'
import Avatar from '@mui/material/Avatar';

function isGasForniture(data) {
    return data.customerId > 200000;
}

function SecondaryMenu() {
    const forniture = useSelector((user) => user.user.podsList);
    const img = useSelector((user) => user.user.info.img);
    const section = useSelector((user) => user.settings.section);
    const orderedForniture = useMemo(() => getOrderedFornitureList(forniture, section), [forniture, section]);
    return (
        <>
            <div className="Forniture">
                <div className="fornitura profile">
                    <NavLink to="/enrica/profilo">

                        <div className="img">
                            <Avatar alt="img_profile" src={img}>
                                <img src='https://my.revoluce.it/area_utente/gestione/img/logo_circle.svg' alt="img_profile"/>
                            </Avatar>
                        </div>
                        <div className="label"><p>Il tuo Profilo</p></div>
                    </NavLink>
                    </div>
                    {orderedForniture !== null ? orderedForniture.map((r, i) => <Forniture key={i} data={r} isActive={i === 0} />) : null}
                </div>
            <Navigator />
        </>
    )
}

export function getOrderedFornitureList(forniture, section) {
    // Check section=true and forniture is valid
    if (section && forniture && forniture.length > 0 && isGasForniture(forniture[0])) {
        const index = forniture.findIndex((data) => !isGasForniture(data));  // find first non-gas forniture
        if (index >= 0) {
            return [forniture[index], forniture[0], ...forniture.slice(1, index), ...forniture.slice(index+1)];
        }
    }
    return forniture;
}

export default SecondaryMenu
